import React from "react";
import { isEmpty } from "../../utils/helpers";
import { ReactSelectOptionObject } from "../InputSelectCustom";

export default function InputSelectOption({
  label,
  value
}: ReactSelectOptionObject) {
  return (
    <option value={!isEmpty(value) ? String(value) : ""}>
      {label || value}
    </option>
  );
}
